"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ShapeBaseGLFilter = _interopRequireDefault(require("./ShapeBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ShapeDogSmoothGLFilter extends _ShapeBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision highp float;

        uniform sampler2D t_tex;
        uniform sampler2D t_tex_2;
        uniform float expos[40];
        uniform float radius;
        uniform vec2 screenSize;

        vec2 getDirectionAt(vec2 pos)
        {
            vec2 dir = texture2D(t_tex_2,pos).xy;
            return 2.0*dir - vec2(1.0);
        }

        void move(inout vec2 pos, inout vec2 dir) {
            vec2 mDir;
            mDir = getDirectionAt(pos);
            if (dot(mDir, dir) < 0.0) mDir = -mDir; // prevent loops
            dir = mDir;
            pos += screenSize * mDir ; // do the actual move
        }

        void main()
        {
            vec2 uv = gl_FragCoord.xy * screenSize;

            vec4 srcRGBA = texture2D(t_tex, uv);
            vec4 c = expos[0] * srcRGBA; // initialize with central value

            vec2 pos, dir, org_dir;
            org_dir = getDirectionAt(uv);
            dir = org_dir;

            for(int i=0; i<2; ++i) // move forward first, then backward
            {
                pos = uv; // start in center position

                move(pos, dir);  // move in the direction of the t_tex_2 field
                c += expos[1] * texture2D(t_tex, pos);

                move(pos, dir);  // move in the direction of the t_tex_2 field
                c += expos[2] * texture2D(t_tex, pos);

                move(pos, dir);  // move in the direction of the t_tex_2 field
                c += expos[3] * texture2D(t_tex, pos);

                move(pos, dir);  // move in the direction of the t_tex_2 field
                c += expos[4] * texture2D(t_tex, pos);
                dir = - org_dir;
            } // forward and backward

            gl_FragColor = c;
        }
        `;
    super(fsSource);
  }

  setTexture2(texture) {
    this._texture2 = texture;
  }

  getTexture2() {
    return this._texture2;
  }

  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.uSampler2 = gl.getUniformLocation(program, 't_tex_2');
    uniformLocations.radius = gl.getUniformLocation(program, 'radius');
    uniformLocations.expos = gl.getUniformLocation(program, 'expos[0]');
    return uniformLocations;
  }

  willDraw(gl) {
    super.willDraw(gl);

    if (this._texture2 === null || this._texture2 === undefined) {
      return;
    }

    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, this._texture2);
    gl.uniform1i(this.uniformLocations.uSampler2, 1);
    var radius = Math.max(1.0, 2.0 * 2.5);
    radius = Math.min(40.0, radius); // we only have 40 storage locations assigned below in the code!

    gl.uniform1i(this.uniformLocations.radius, radius);
    const maxR = Math.floor(radius);
    const fac = -1.0 / (2.0 * 2.5 * 2.5); // -1.0/(radius*radius)

    var sum = 1.0;
    var expos = new Array(40);
    expos[0] = sum;
    var i;

    for (i = 1; i < maxR; i++) {
      const v = Math.exp(i * i * fac);
      expos[i] = v; // there is no overinputImageTexture2 checking (and it won't fail), but only the valid entries as defined in the code will be assigned to

      sum = sum + 2.0 * v;
    } // do some sort of normalization here...


    for (i = 0; i < maxR; i++) {
      expos[i] = expos[i] / sum;
    }

    gl.uniform1fv(this.uniformLocations.expos, expos);
  }

}

exports.default = ShapeDogSmoothGLFilter;